<template>
  <div class="page page-password-reset">
    <a href="/" class="logo">
      <img :src="assetsPath('logo.svg')" :alt="$store.getters.appName" />
    </a>
    <FormPasswordReset />
  </div>
</template>

<script>
  import FormPasswordReset from '@/components/forms/FormPasswordReset'

  export default {
    name: 'page-password-reset',
    components: {
      FormPasswordReset,
    },
    mounted() {
      if (this.$store.getters.userAuthenticated) {
        this.$router.push({
          name: 'home',
        })
      }
    },
  }
</script>
